import { pitchGetterFollowup } from "@/app/(application)/(normal)/create/components/input/pitchGetterFollowup";
import { pitchShiftMiddleware } from "@/app/(application)/(normal)/create/components/input/pitchShiftMiddleware";
import { vibratoMiddleware } from "@/app/(application)/(normal)/create/components/input/vibratoMiddleware";
import { useAudioInput } from "@/lib/zustand/useAudioInput";
import { useNamedKey } from "@/lib/zustand/useKey";
import { useNamedPitchCorrection } from "@/lib/zustand/usePitchCorrection";
import { applyPitchesUsingUpdatedPitchRequest } from "@/utils/applyPitchesUsingUpdatedPitchRequest";

export const usePitchesToConversionBackend = ({
  inputNamespace,
  namespacePitchCorrection,
  nameSpaceKey,
}: {
  inputNamespace: string;
  namespacePitchCorrection: string;
  nameSpaceKey: string;
}) => {
  const useConversionInput = useAudioInput((state) =>
    state.getNamedStore(inputNamespace)
  );
  const selectedFileCover = useConversionInput(
    (state) => state.selectedFileCover
  );

  const pitchGetter = useConversionInput((state) => state.pitchGetter);

  const usePitchCorrection = useNamedPitchCorrection((state) =>
    state.getNamedStore(namespacePitchCorrection)
  );
  const useKey = useNamedKey((state) => state.getNamedStore(nameSpaceKey));
  const keyZ = useKey((state) => state.key);
  const pitches = usePitchCorrection((state) => state.pitches);

  const updatedPitchRequest = usePitchCorrection(
    (state) => state.updatedPitchRequest
  );

  const vibratoLevelZ = usePitchCorrection((state) => state.vibratoLevel);
  const pitchShiftLevelZ = usePitchCorrection((state) => state.pitchLevel);

  const hasNoPitchEdits =
    pitchShiftLevelZ === 0 && vibratoLevelZ === 0 && pitches.length === 0;
  if (hasNoPitchEdits || selectedFileCover === null || pitchGetter === null) {
    return null;
  }
  return {
    pitches:
      pitches.length > 0 ?
        applyPitchesUsingUpdatedPitchRequest(updatedPitchRequest, pitches)
      : pitchGetterFollowup(
          vibratoMiddleware(vibratoLevelZ),
          pitchShiftMiddleware(pitchShiftLevelZ, keyZ)
        )(pitchGetter),
    dirty: pitches.length > 0 || vibratoLevelZ !== 0 || pitchShiftLevelZ !== 0,
  };
};
